import { AdyenEnvironment, PRODUCTION_ENVIRONMENT_DOMAIN_NAME } from '../constants';

export const mapAdyenEnvironmentFromDomain = (checkoutEnvironment: string): AdyenEnvironment =>
  checkoutEnvironment === PRODUCTION_ENVIRONMENT_DOMAIN_NAME ? 'live' : 'test';
